import {
  getGoogleMerchantSyncEndpoints,
  IGoogleMerchantFullSyncEnqueueDTO,
  IGoogleMerchantDeltaSyncEnqueueDTO,
  IGoogleMerchantProductSyncEnqueueDTO,
  IGoogleMerchantSyncEnqueueResponse,
  IGetGoogleMerchantSyncRunsResponse,
  IGetGoogleMerchantSyncRunsDTO,
} from '@/models/googleMerchantSync.model';

import { httpClient, ApiResponse } from '@/utils';

class GoogleMerchantSyncAPI {
  static getSyncRuns({
    channelSlug,
    ...params
  }: IGetGoogleMerchantSyncRunsDTO): ApiResponse<IGetGoogleMerchantSyncRunsResponse> {
    const { GET_MERCHANT_SYNC_RUNS } = getGoogleMerchantSyncEndpoints({ channelSlug });

    return httpClient.get<IGetGoogleMerchantSyncRunsResponse>(GET_MERCHANT_SYNC_RUNS, {
      params,
    });
  }

  static syncFull({
    channelSlug,
    ...data
  }: IGoogleMerchantFullSyncEnqueueDTO): ApiResponse<IGoogleMerchantSyncEnqueueResponse> {
    const { SYNC_FULL } = getGoogleMerchantSyncEndpoints({ channelSlug });

    return httpClient.post<IGoogleMerchantSyncEnqueueResponse>(SYNC_FULL, data);
  }

  static syncDelta({
    channelSlug,
    ...data
  }: IGoogleMerchantDeltaSyncEnqueueDTO): ApiResponse<IGoogleMerchantSyncEnqueueResponse> {
    const { SYNC_DELTA } = getGoogleMerchantSyncEndpoints({ channelSlug });

    return httpClient.post<IGoogleMerchantSyncEnqueueResponse>(SYNC_DELTA, data);
  }

  static syncProduct({
    channelSlug,
    sku,
    ...data
  }: IGoogleMerchantProductSyncEnqueueDTO): ApiResponse<IGoogleMerchantSyncEnqueueResponse> {
    const { SYNC_PRODUCT } = getGoogleMerchantSyncEndpoints({ channelSlug });

    return httpClient.post<IGoogleMerchantSyncEnqueueResponse>(SYNC_PRODUCT, data, {
      params: { sku },
    });
  }
}

export default GoogleMerchantSyncAPI;
